// @ts-nocheck
import dynamic from "next/dynamic";
import styles from "./pages.module.css";
import Loader from "../loader/loader";
import Footer from "../footer/footer";

const formatComponentName = (name: string) => {
  return name
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join("");
};

// Dynamically load a component
const loadComponent = (componentPath: string) => {
  const parts = componentPath.split(".");
  if (parts.length < 2) return null;

  const folder = parts[0];
  const name = parts[1];

  try {
    return dynamic(
      async () => {
        // import component dynamically
        const mod = await import(`../${name}/${name}`);
        return mod?.default || mod[name] || mod;
      },
      {
        loading: () => <Loader />,
        ssr: true, // enable SSR for Google screenshot
      }
    );
  } catch (error) {
    console.warn(`Component not found: ${componentPath}`);
    return null;
  }
};

export default function Pages({
  sections = [],
  menuList,
  footerData,
  industries,
  sectionsList,
  languages,
  regions,
  solutions,
  types,
  vxiContent,
  CXAHub,
  referenceList,
  slugPath = [],
  menuDataForAutoFilter
}) {
  // --- Hero + Announcements ---
  const announcementIndex = sections.findIndex(
    (section) => (section?.attributes?.__component ?? section?.__component) === "layout.announcement"
  );
  const hero = sections.find(
    (section) => (section?.attributes?.__component ?? section?.__component) === "layout.hero"
  );
  let heroPageFilter = sections.find(
    (section) => (section?.attributes?.__component ?? section?.__component) === "specials.hero-page-filter"
  );

  if (heroPageFilter) {
    heroPageFilter = {
      ...heroPageFilter,
      attributes: {
        ...heroPageFilter?.attributes,
        filters: [industries, languages, regions, sectionsList, solutions, types],
      },
    };
  }

  if (announcementIndex !== -1 && hero) {
    const [announcements] = sections.splice(announcementIndex, 1);
    if (hero?.attributes) {
      hero.attributes.announcements = announcements?.attributes ?? announcements;
    }
  }

  const lastSection = sections[sections.length - 1];
  const lastSectionAttrs = lastSection?.attributes ?? lastSection;
  const isLastNoGap =
    lastSectionAttrs?.__component === "base.home" ||
    lastSectionAttrs?.__component === "layout.navigation-split" ||
    lastSectionAttrs?.__component === "specials.hub-spot-hero" ||
    (lastSectionAttrs?.__component === "layout.banner" && lastSectionAttrs?.coverage === "full") ||
    (lastSectionAttrs?.__component === "specials.banner-drop-and-go" &&
      lastSectionAttrs?.coverage === "full");

  const isFaked =
    lastSectionAttrs?.__component === "layout.image-text-split" ||
    lastSectionAttrs?.__component === "specials.filtered-content-slider";

  // Preload components
  const componentsMap = sections.reduce((acc, section) => {
    const sectionAttrs = section?.attributes ?? section;
    //console.log("Loading component for section:", sectionAttrs?.__component);
    acc[sectionAttrs?.__component] = loadComponent(sectionAttrs?.__component);
    return acc;
  }, {});

  return (
    <div
      className={`${styles.pages} ${isLastNoGap ? styles.noGapLast : ""} ${
        isFaked ? styles.addMoreGap : ""
      }`}
      style={{
        "--title-color": slugPath.includes("cxa-hub") ? "#F8B84E" : "inherit",
      }}
    >
      {sections.map((section, index) => {
        const sectionAttrs = section?.attributes ?? section;
        const Component = componentsMap[sectionAttrs?.__component];
        if (!Component) {
          console.warn("Skipping section. Component not found:", sectionAttrs?.__component);
          return null;
        }

        return (
          <Component
            key={index}
            {...sectionAttrs}
            {...(sectionAttrs?.__component === "specials.hero-page-filter" && {
              vxiContent: [...vxiContent],
              languages,
              industries,
              regions,
              sections: sectionsList,
              solutions,
              types,
              menuDataForAutoFilter
            })}
            {...(slugPath.includes("cxa-hub") && { titlePositioning: "center" })}
            {...(sectionAttrs?.__component === "layout.filtered-hub" && { CXAHub })}
          />
        );
      })}

      <Footer
        footerLink={footerData?.attributes?.footerLink}
        button={footerData?.attributes?.button}
        socials={footerData?.attributes?.socials}
      />
    </div>
  );
}